export function previewText(wording, names, date) {
  const clean = (value, max) =>
    typeof value == "string"
      ? value
          .normalize("NFC")
          .replace(
            /\r\n?/g,
            `
`,
          )
          .trim()
          .slice(0, max)
      : "";
  return (
    clean(wording, 1e3) ||
    [clean(names, 200), clean(date, 60)].filter(Boolean).join(`
`)
  );
}
export function safeMagnetPreview(value) {
  return typeof value == "string" &&
    value.length <= 8e5 &&
    /^data:image\/(?:jpeg|png);base64,[A-Za-z0-9+/]+={0,2}$/.test(value)
    ? value
    : "";
}
export function safeCardStyle(value) {
  return typeof value == "string" && /^[a-z0-9-]{1,30}$/.test(value)
    ? value
    : "classic";
}
const f = (n) => Math.round(n * 10) / 10,
  svgURL = (body) =>
    'url("data:image/svg+xml,' +
    encodeURIComponent(
      "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 700' preserveAspectRatio='none'>" +
        body +
        "</svg>",
    ) +
    '")',
  g = (inner, t = "", extra = "") =>
    `<g${t ? ` transform='${t}'` : ""}${extra}>${inner}</g>`,
  quad = (p0, c, p1, t) => {
    const m = 1 - t;
    return [
      m * m * p0[0] + 2 * m * t * c[0] + t * t * p1[0],
      m * m * p0[1] + 2 * m * t * c[1] + t * t * p1[1],
    ];
  },
  quadAngle = (p0, c, p1, t) => {
    const a = quad(p0, c, p1, Math.max(0, t - 0.01)),
      b = quad(p0, c, p1, Math.min(1, t + 0.01));
    return (Math.atan2(b[1] - a[1], b[0] - a[0]) * 180) / Math.PI;
  },
  curve = (p0, c, p1, stroke, w = 1.4, extra = "") =>
    `<path d='M${f(p0[0])} ${f(p0[1])}Q${f(c[0])} ${f(c[1])} ${f(p1[0])} ${f(p1[1])}' stroke='${stroke}' stroke-width='${w}' fill='none' stroke-linecap='round'${extra}/>`,
  leaf = (x, y, len, wid, ang, fill, op = 1) =>
    `<path d='M0 0Q${f(len / 2)} ${f(-wid)} ${len} 0Q${f(len / 2)} ${wid} 0 0Z' fill='${fill}' opacity='${op}' transform='translate(${f(x)} ${f(y)}) rotate(${f(ang)})'/>`,
  leafyBranch = (
    p0,
    c,
    p1,
    {
      n = 9,
      len = 18,
      wid = 6,
      colors = ["#8da48a"],
      spread = 45,
      stem: stem2 = "#7d9479",
      round = !1,
      start = 0.08,
    },
  ) => {
    let out = curve(p0, c, p1, stem2, 1.4);
    for (let i = 0; i < n; i++) {
      const t = start + ((1 - start) * i) / Math.max(1, n - 1),
        [x, y] = quad(p0, c, p1, t),
        a = quadAngle(p0, c, p1, t),
        side = i % 2 ? 1 : -1,
        col = colors[i % colors.length];
      if (round) {
        const r = len / 2,
          rad = ((a + side * 70) * Math.PI) / 180;
        out += `<ellipse cx='${f(x + Math.cos(rad) * r)}' cy='${f(y + Math.sin(rad) * r)}' rx='${f(r)}' ry='${f(r * 0.82)}' fill='${col}' transform='rotate(${f(a)} ${f(x + Math.cos(rad) * r)} ${f(y + Math.sin(rad) * r)})'/>`;
      } else out += leaf(x, y, len, wid, a + side * spread, col);
    }
    return out;
  },
  pineBranch = (p0, c, p1, color, n = 16, needle = 11) => {
    let out = curve(p0, c, p1, color, 2);
    for (let i = 0; i < n; i++) {
      const t = 0.04 + (0.94 * i) / (n - 1),
        [x, y] = quad(p0, c, p1, t),
        a = (quadAngle(p0, c, p1, t) * Math.PI) / 180,
        l = needle * (1 - t * 0.35);
      for (const s of [-1, 1])
        for (const k of [0.55, 0.95]) {
          const ang = a + s * k,
            dx = Math.cos(ang) * l,
            dy = Math.sin(ang) * l;
          out += `<path d='M${f(x)} ${f(y)}l${f(dx)} ${f(dy)}' stroke='${color}' stroke-width='1.6' stroke-linecap='round'/>`;
        }
    }
    return out;
  },
  hollyLeaf = (x, y, s, ang, fill = "#2f5a3a") =>
    `<path d='M0 0C4 -5 9 -3 11 -7C13 -3 18 -5 20 -9C21 -4 26 -4 28 -6C27 -1 30 2 32 3C27 4 26 8 21 8C19 11 14 9 11 12C10 8 5 8 2 5C3 3 1 1 0 0Z' fill='${fill}' transform='translate(${f(x)} ${f(y)}) rotate(${f(ang)}) scale(${s})'/><path d='M2 2L29 1' stroke='#22442c' stroke-width='.8' transform='translate(${f(x)} ${f(y)}) rotate(${f(ang)}) scale(${s})'/>`,
  hollyLeaf2 = (x, y, s, ang, fill = "#2b5235") =>
    g(
      `<path d='M0 0Q5 -6 10 -14Q14 -9 22 -16Q26 -10 34 -15Q38 -9 46 -11Q50 -5 58 0Q50 5 46 11Q38 9 34 15Q26 10 22 16Q14 9 10 14Q5 6 0 0Z' fill='${fill}'/><path d='M3 0Q30 -1.5 54 0' stroke='#6f9a72' stroke-width='1.1' fill='none' stroke-linecap='round'/>`,
      `translate(${f(x)} ${f(y)}) rotate(${f(ang)}) scale(${s})`,
    ),
  firSprig = (p0, c, p1, n = 22) =>
    leafyBranch(p0, c, p1, {
      n,
      len: 17,
      wid: 3,
      colors: ["#2f4a35", "#4e6b4f", "#3b5d43", "#56785a"],
      spread: 38,
      stem: "#3b5d43",
      start: 0.03,
    }),
  hollyCorner = (small = !1) =>
    firSprig([-10, -6], [80, 20], [190, 26], 34) +
    firSprig([-6, -10], [20, 80], [22, 196], 34) +
    firSprig([-4, -4], [56, 24], [104, 66], 18) +
    (small ? "" : firSprig([-4, -2], [30, 60], [70, 140], 18)) +
    hollyLeaf2(62, 52, 1.3, 165, "#3f6e47") +
    hollyLeaf2(62, 52, 1.15, 112, "#2b5235") +
    hollyLeaf2(62, 52, 1.35, 20, "#2b5235") +
    hollyLeaf2(62, 52, 1.3, 68, "#3f6e47") +
    berries(54, 44, 7) +
    berries(70, 58, 5.5) +
    sparkle(150, 70, 4, "#c9a45c", 0.9) +
    sparkle(30, 150, 3.5, "#c9a45c", 0.9),
  plaidBow = (x, y, s) =>
    g(
      "<path d='M-4 8L-36 66L-22 58L-14 72L6 12Z' fill='url(#bplaid)' stroke='#6d1420' stroke-width='1.4'/><path d='M4 8L36 66L22 58L14 72L-6 12Z' fill='url(#bplaid)' stroke='#6d1420' stroke-width='1.4'/><path d='M0 0C-14 -38 -66 -42 -66 -8C-66 20 -24 22 0 0Z' fill='url(#bplaid)' stroke='#6d1420' stroke-width='1.6'/><path d='M0 0C14 -38 66 -42 66 -8C66 20 24 22 0 0Z' fill='url(#bplaid)' stroke='#6d1420' stroke-width='1.6'/><path d='M-6 -2C-24 -16 -44 -16 -52 -6M6 -2C24 -16 44 -16 52 -6' stroke='#1a1414' stroke-width='1.4' fill='none' opacity='.35'/><rect x='-11' y='-12' width='22' height='24' rx='6' fill='url(#bplaid)' stroke='#6d1420' stroke-width='1.6'/>",
      `translate(${x} ${y}) scale(${s})`,
    ),
  berries = (x, y, r = 5, c = "#a3202f") =>
    `<circle cx='${x}' cy='${y}' r='${r}' fill='${c}'/><circle cx='${x + r * 1.5}' cy='${y + r * 0.6}' r='${r * 0.9}' fill='${c}'/><circle cx='${x + r * 0.5}' cy='${y + r * 1.6}' r='${r * 0.85}' fill='#c23a45'/><circle cx='${f(x - r * 0.3)}' cy='${f(y - r * 0.3)}' r='${f(r * 0.3)}' fill='#fff' opacity='.5'/>`,
  pinecone = (x, y, s, ang) => {
    let o = "";
    for (let r = 0; r < 5; r++)
      for (let k = 0; k < 3 - (r > 2 ? 1 : 0); k++)
        o += `<ellipse cx='${f((k - (2 - (r > 2 ? 1 : 0)) / 2) * 6)}' cy='${r * 6}' rx='4' ry='3.4' fill='${r % 2 ? "#8a5a35" : "#9c6a40"}' stroke='#6e4426' stroke-width='.6'/>`;
    return g(o, `translate(${x} ${y}) rotate(${ang}) scale(${s})`);
  },
  flower5 = (x, y, r, petal, center = "#d9a441", n = 5, op = 1) => {
    let p = "";
    for (let i = 0; i < n; i++)
      p += `<ellipse cx='${x}' cy='${f(y - r * 0.55)}' rx='${f(r * 0.42)}' ry='${f(r * 0.6)}' fill='${petal}' transform='rotate(${f((i * 360) / n)} ${x} ${y})'/>`;
    return `<g opacity='${op}'>${p}<circle cx='${x}' cy='${y}' r='${f(r * 0.26)}' fill='${center}'/></g>`;
  },
  daisy = (x, y, r) =>
    flower5(x, y, r, "#fffdf8", "#e8b93e", 11) +
    `<circle cx='${x}' cy='${y}' r='${f(r * 1.02)}' fill='none' stroke='#e6e1d3' stroke-width='.6'/>`,
  rose = (x, y, r, c1, c2) =>
    `<circle cx='${x}' cy='${y}' r='${r}' fill='${c1}'/><path d='M${f(x - r * 0.55)} ${f(y + r * 0.1)}a${f(r * 0.55)} ${f(r * 0.55)} 0 1 1 ${f(r * 0.9)} ${f(r * 0.35)}M${f(x - r * 0.25)} ${f(y)}a${f(r * 0.3)} ${f(r * 0.3)} 0 1 1 ${f(r * 0.45)} ${f(r * 0.15)}M${f(x - r * 0.8)} ${f(y + r * 0.35)}a${f(r * 0.8)} ${f(r * 0.7)} 0 0 0 ${f(r * 1.5)} ${f(r * 0.15)}' stroke='${c2}' stroke-width='${f(Math.max(1, r * 0.12))}' fill='none' stroke-linecap='round'/>`,
  lavender = (x, y, h, c = "#9c86c4") => {
    let o = `<path d='M${x} ${y}q2 ${-h * 0.5} 0 ${-h}' stroke='#7c8a5c' stroke-width='1.3' fill='none'/>`;
    for (let i = 0; i < 7; i++)
      o += `<ellipse cx='${x + (i % 2 ? 2.4 : -2.4)}' cy='${f(y - h + i * 4.2)}' rx='2.6' ry='3.6' fill='${c}'/>`;
    return o;
  },
  poppy = (x, y, r) =>
    `<circle cx='${f(x - r * 0.35)}' cy='${y}' r='${f(r * 0.7)}' fill='#e2774f'/><circle cx='${f(x + r * 0.35)}' cy='${y}' r='${f(r * 0.7)}' fill='#e88a62'/><circle cx='${x}' cy='${f(y - r * 0.35)}' r='${f(r * 0.7)}' fill='#ec9a72'/><circle cx='${x}' cy='${f(y - r * 0.05)}' r='${f(r * 0.22)}' fill='#3e2f22'/>`,
  stem = (x1, y1, x2, y2, bend = 10, c = "#7c8a5c") =>
    `<path d='M${x1} ${y1}Q${f((x1 + x2) / 2 + bend)} ${f((y1 + y2) / 2)} ${x2} ${y2}' stroke='${c}' stroke-width='1.4' fill='none' stroke-linecap='round'/>`,
  grass = (x, y, h, lean, c = "#9aa678") =>
    `<path d='M${x - 2} ${y}Q${x + lean * 0.4} ${f(y - h * 0.6)} ${x + lean} ${y - h}Q${x + lean * 0.3} ${f(y - h * 0.55)} ${x + 2} ${y}Z' fill='${c}'/>`,
  star5 = (x, y, r, fill, op = 1) => {
    let d = "";
    for (let i = 0; i < 10; i++) {
      const a = -Math.PI / 2 + (i * Math.PI) / 5,
        rr = i % 2 ? r * 0.45 : r;
      d +=
        (i ? "L" : "M") +
        f(x + Math.cos(a) * rr) +
        " " +
        f(y + Math.sin(a) * rr);
    }
    return `<path d='${d}Z' fill='${fill}' opacity='${op}'/>`;
  },
  sparkle = (x, y, r, fill, op = 1) =>
    `<path d='M${x} ${y - r}Q${f(x + r * 0.18)} ${f(y - r * 0.18)} ${x + r} ${y}Q${f(x + r * 0.18)} ${f(y + r * 0.18)} ${x} ${y + r}Q${f(x - r * 0.18)} ${f(y + r * 0.18)} ${x - r} ${y}Q${f(x - r * 0.18)} ${f(y - r * 0.18)} ${x} ${y - r}Z' fill='${fill}' opacity='${op}'/>`,
  heart = (x, y, s, fill, op = 1, ang = 0) =>
    `<path d='M0 -3C0 -9 -9 -10 -9 -3C-9 3 0 7 0 10C0 7 9 3 9 -3C9 -10 0 -9 0 -3Z' fill='${fill}' opacity='${op}' transform='translate(${x} ${y}) rotate(${ang}) scale(${s})'/>`,
  snowflake = (x, y, r, c, op = 0.8, w = 1.3) => {
    let o = "";
    for (let i = 0; i < 6; i++) {
      const a = (i * Math.PI) / 3,
        cx = Math.cos(a),
        sy = Math.sin(a);
      o += `<path d='M${x} ${y}L${f(x + cx * r)} ${f(y + sy * r)}'/>`;
      for (const k of [0.45, 0.72]) {
        const bx = x + cx * r * k,
          by = y + sy * r * k,
          l = r * (k === 0.45 ? 0.28 : 0.2);
        for (const s of [-1, 1]) {
          const b = a + (s * Math.PI) / 4;
          o += `<path d='M${f(bx)} ${f(by)}l${f(Math.cos(b) * l)} ${f(Math.sin(b) * l)}'/>`;
        }
      }
    }
    return `<g stroke='${c}' stroke-width='${w}' stroke-linecap='round' opacity='${op}'>${o}</g>`;
  },
  bauble = (x, y, r, fill, top, shine = "#fff") =>
    `<path d='M${x} ${top}V${f(y - r - 5)}' stroke='#b49a62' stroke-width='1'/><rect x='${f(x - r * 0.32)}' y='${f(y - r - 6)}' width='${f(r * 0.64)}' height='6' rx='1.5' fill='#c9a45c'/><circle cx='${x}' cy='${y}' r='${r}' fill='${fill}'/><path d='M${f(x - r)} ${y}Q${x} ${f(y + r * 0.35)} ${x + r} ${y}' stroke='#fffdf8' stroke-width='${f(r * 0.14)}' fill='none' opacity='.55'/><ellipse cx='${f(x - r * 0.38)}' cy='${f(y - r * 0.42)}' rx='${f(r * 0.2)}' ry='${f(r * 0.3)}' fill='${shine}' opacity='.6' transform='rotate(35 ${f(x - r * 0.38)} ${f(y - r * 0.42)})'/>`,
  balloon = (x, y, r, fill, len = 80, sway = 8) =>
    `<path d='M${x} ${f(y + r * 1.22 + 4)}c${sway} ${f(len * 0.25)} ${-sway} ${f(len * 0.5)} 0 ${f(len * 0.75)}s${sway} ${f(len * 0.2)} ${f(sway * 0.3)} ${f(len * 0.25)}' stroke='#a8968a' stroke-width='1' fill='none'/><ellipse cx='${x}' cy='${y}' rx='${r}' ry='${f(r * 1.2)}' fill='${fill}'/><path d='M${f(x - 3.5)} ${f(y + r * 1.24)}h7l-3.5 -5z' fill='${fill}'/><ellipse cx='${f(x - r * 0.38)}' cy='${f(y - r * 0.45)}' rx='${f(r * 0.2)}' ry='${f(r * 0.34)}' fill='#fff' opacity='.55' transform='rotate(-25 ${f(x - r * 0.38)} ${f(y - r * 0.45)})'/>`,
  bunting = (p0, c, p1, n, colors, h = 30, w = 26) => {
    let o = curve(p0, c, p1, "#8a7a6a", 1.2);
    for (let i = 0; i < n; i++) {
      const t = (i + 0.5) / n,
        [x, y] = quad(p0, c, p1, t),
        a = quadAngle(p0, c, p1, t);
      o += `<path d='M${f(-w / 2)} 0L${f(w / 2)} 0L0 ${h}Z' fill='${colors[i % colors.length]}' transform='translate(${f(x)} ${f(y)}) rotate(${f(a)})'/>`;
    }
    return o;
  },
  mortarboard = (x, y, s, fill, tassel = "#c9a45c", ang = 0) =>
    g(
      `<path d='M-36 6L-24 16V28Q0 38 24 28V16L36 6' fill='${fill}' opacity='.92'/><path d='M0 -14L48 4L0 22L-48 4Z' fill='${fill}'/><path d='M0 -14L48 4L0 22L-48 4Z' fill='none' stroke='${tassel}' stroke-width='1' opacity='.5'/><circle cx='0' cy='4' r='3.2' fill='${tassel}'/><path d='M0 4Q30 8 34 12V34' stroke='${tassel}' stroke-width='2' fill='none'/><path d='M30 34h8l2 14h-12z' fill='${tassel}'/>`,
      `translate(${x} ${y}) rotate(${ang}) scale(${s})`,
    ),
  diploma = (x, y, s, ang, ribbon = "#28394d") =>
    g(
      `<rect x='-40' y='-9' width='80' height='18' rx='3' fill='#f7f1df' stroke='#cbbf9c' stroke-width='1.2'/><ellipse cx='40' cy='0' rx='4.5' ry='9' fill='#ece3c8' stroke='#cbbf9c' stroke-width='1.2'/><ellipse cx='-40' cy='0' rx='4.5' ry='9' fill='#f7f1df' stroke='#cbbf9c' stroke-width='1.2'/><rect x='-5' y='-10' width='10' height='20' fill='${ribbon}'/><path d='M-2 9l-10 18l7-3l3 7M2 9l10 18l-7-3l-3 7' fill='${ribbon}'/>`,
      `translate(${x} ${y}) rotate(${ang}) scale(${s})`,
    ),
  cloud = (x, y, s, fill = "#fff", shade = "#dbe6ec") =>
    g(
      `<path d='M-30 10a14 14 0 0 1 4 -27a19 19 0 0 1 34 -6a15 15 0 0 1 26 9a12 12 0 0 1 -2 24z' fill='${shade}' transform='translate(2 4)'/><path d='M-30 10a14 14 0 0 1 4 -27a19 19 0 0 1 34 -6a15 15 0 0 1 26 9a12 12 0 0 1 -2 24z' fill='${fill}'/>`,
      `translate(${x} ${y}) scale(${s})`,
    ),
  pineTree = (x, y, h, fill, snow = "#fffdf8") => {
    const w = h * 0.62;
    return `<rect x='${f(x - h * 0.04)}' y='${f(y - h * 0.1)}' width='${f(h * 0.08)}' height='${f(h * 0.1)}' fill='#5a4630'/><path d='M${x} ${y - h}L${f(x + w * 0.3)} ${f(y - h * 0.66)}H${f(x + w * 0.18)}L${f(x + w * 0.42)} ${f(y - h * 0.38)}H${f(x + w * 0.28)}L${f(x + w / 2)} ${f(y - h * 0.1)}H${f(x - w / 2)}L${f(x - w * 0.28)} ${f(y - h * 0.38)}H${f(x - w * 0.42)}L${f(x - w * 0.18)} ${f(y - h * 0.66)}H${f(x - w * 0.3)}Z' fill='${fill}'/><path d='M${x} ${y - h}L${f(x + w * 0.14)} ${f(y - h * 0.84)}Q${x} ${f(y - h * 0.8)} ${f(x - w * 0.14)} ${f(y - h * 0.84)}Z' fill='${snow}' opacity='.9'/>`;
  },
  duck = (x, y, s) =>
    g(
      "<path d='M-30 4C-30 -10 -14 -14 0 -8C6 -24 30 -24 30 -6C30 2 26 6 20 8C26 14 22 26 4 26H-14C-26 26 -32 16 -30 4Z' fill='#f6cf57'/><path d='M30 -10L44 -6L30 -2Z' fill='#ef9a4a'/><circle cx='18' cy='-12' r='2.6' fill='#3e2f22'/><path d='M-14 6Q-2 16 10 6' stroke='#e2b13e' stroke-width='2' fill='none' stroke-linecap='round'/>",
      `translate(${x} ${y}) scale(${s})`,
    ),
  footprint = (x, y, s, ang, fill) =>
    g(
      `<path d='M0 0C-8 0 -11 10 -10 20C-9 30 -4 36 1 36C6 36 9 30 8 22C7 14 8 0 0 0Z' fill='${fill}'/><circle cx='-8' cy='-6' r='3.6' fill='${fill}'/><circle cx='-1' cy='-9' r='3' fill='${fill}'/><circle cx='5' cy='-8' r='2.6' fill='${fill}'/><circle cx='9' cy='-4' r='2.2' fill='${fill}'/><circle cx='11' cy='1' r='1.9' fill='${fill}'/>`,
      `translate(${x} ${y}) rotate(${ang}) scale(${s})`,
    ),
  butterfly = (x, y, s, c1, c2, ang = 0) =>
    g(
      `<path d='M0 0C-10 -20 -30 -18 -26 -4C-24 4 -10 4 0 0Z' fill='${c1}'/><path d='M0 0C10 -20 30 -18 26 -4C24 4 10 4 0 0Z' fill='${c1}'/><path d='M0 0C-8 6 -20 14 -14 20C-8 24 -2 12 0 0Z' fill='${c2}'/><path d='M0 0C8 6 20 14 14 20C8 24 2 12 0 0Z' fill='${c2}'/><path d='M0 -8V16' stroke='#4a3b2e' stroke-width='2.4' stroke-linecap='round'/><path d='M0 -8Q-4 -16 -8 -18M0 -8Q4 -16 8 -18' stroke='#4a3b2e' stroke-width='1' fill='none'/>`,
      `translate(${x} ${y}) rotate(${ang}) scale(${s})`,
    ),
  bee = (x, y, s, ang = 0) =>
    g(
      "<ellipse cx='-4' cy='-10' rx='7' ry='9' fill='#e8f0f4' opacity='.9' transform='rotate(-20 -4 -10)'/><ellipse cx='5' cy='-10' rx='6' ry='8' fill='#e8f0f4' opacity='.9' transform='rotate(20 5 -10)'/><ellipse cx='0' cy='0' rx='13' ry='9' fill='#f2c94c'/><path d='M-4 -8.5V8.5M3 -8V8' stroke='#3e2f22' stroke-width='3'/><circle cx='12' cy='-1' r='1.6' fill='#3e2f22'/>",
      `translate(${x} ${y}) rotate(${ang}) scale(${s})`,
    ),
  rings = (x, y, r, c) =>
    `<circle cx='${f(x - r * 0.55)}' cy='${y}' r='${r}' fill='none' stroke='${c}' stroke-width='${f(r * 0.2)}'/><circle cx='${f(x + r * 0.55)}' cy='${y}' r='${r}' fill='none' stroke='${c}' stroke-width='${f(r * 0.2)}'/><path d='M${f(x + r * 0.55)} ${f(y - r - r * 0.55)}l${f(r * 0.3)} ${f(r * 0.45)}l${f(-r * 0.3)} ${f(r * 0.25)}l${f(-r * 0.3)} ${f(-r * 0.25)}z' fill='${c}'/>`,
  decoFan = (cx, cy, r, rot, c) => {
    let o = "";
    for (const k of [1, 0.78, 0.56])
      o += `<path d='M${f(r * k)} 0A${f(r * k)} ${f(r * k)} 0 0 1 0 ${f(r * k)}' fill='none' stroke='${c}' stroke-width='1.2'/>`;
    for (let i = 0; i <= 6; i++) {
      const a = (i * Math.PI) / 12;
      o += `<path d='M${f(Math.cos(a) * r * 0.3)} ${f(Math.sin(a) * r * 0.3)}L${f(Math.cos(a) * r * 0.56)} ${f(Math.sin(a) * r * 0.56)}' stroke='${c}' stroke-width='1'/>`;
    }
    return (
      (o += `<circle cx='0' cy='0' r='${f(r * 0.16)}' fill='${c}'/>`),
      g(o, `translate(${cx} ${cy}) rotate(${rot})`)
    );
  },
  cake = (x, y, s) =>
    g(
      "<rect x='-34' y='-6' width='68' height='34' rx='4' fill='#f5c6c2'/><rect x='-26' y='-34' width='52' height='28' rx='4' fill='#fbe3d6'/><path d='M-34 -2h68v6q-6 6 -10 0t-10 0t-10 0t-10 0t-10 0t-10 0t-8 0z' fill='#fffdf8'/><path d='M-26 -30h52v5q-6 6 -10 0t-10 0t-10 0t-10 0t-12 0z' fill='#fffdf8'/><rect x='-40' y='28' width='80' height='5' rx='2' fill='#d9c2a0'/><g fill='#f2b33d'><rect x='-14' y='-50' width='4' height='16' rx='1'/><rect x='-2' y='-52' width='4' height='18' rx='1'/><rect x='10' y='-50' width='4' height='16' rx='1'/></g><g fill='#f0715a'><path d='M-12 -60q4 5 0 9q-4 -4 0 -9z'/><path d='M0 -62q4 5 0 9q-4 -4 0 -9z'/><path d='M12 -60q4 5 0 9q-4 -4 0 -9z'/></g><g fill='#5bb3a8'><circle cx='-20' cy='10' r='2'/><circle cx='0' cy='14' r='2'/><circle cx='20' cy='10' r='2'/></g>",
      `translate(${x} ${y}) scale(${s})`,
    ),
  twineBow = (x, y, s, c = "#a88560") =>
    g(
      `<path d='M0 0C-14 -16 -34 -12 -30 0C-26 10 -10 4 0 0ZM0 0C14 -16 34 -12 30 0C26 10 10 4 0 0Z' fill='none' stroke='${c}' stroke-width='2.4'/><path d='M0 0Q-8 16 -16 30M0 0Q8 16 18 28' stroke='${c}' stroke-width='2.4' fill='none' stroke-linecap='round'/><circle cx='0' cy='0' r='3.4' fill='${c}'/>`,
      `translate(${x} ${y}) scale(${s})`,
    ),
  confettiAt = (pts, colors) =>
    pts
      .map(([x, y], i) => {
        const c = colors[i % colors.length],
          r = (i * 53) % 180;
        return i % 4 === 0
          ? `<circle cx='${x}' cy='${y}' r='3.4' fill='${c}'/>`
          : i % 4 === 1
            ? `<rect x='${x - 6}' y='${y - 2.2}' width='12' height='4.4' rx='1' fill='${c}' transform='rotate(${r} ${x} ${y})'/>`
            : i % 4 === 2
              ? `<path d='M${x - 8} ${y}q4 -6 8 0t8 0' stroke='${c}' stroke-width='2.2' fill='none' stroke-linecap='round' transform='rotate(${r} ${x} ${y})'/>`
              : star5(x, y, 4.5, c);
      })
      .join(""),
  scatter = (pts, fn) => pts.map(([x, y, s = 1], i) => fn(x, y, s, i)).join(""),
  patterns =
    "<defs><pattern id='plaid' width='18' height='18' patternUnits='userSpaceOnUse'><rect width='18' height='18' fill='#a3202f'/><rect width='9' height='18' fill='#1c1c1c' opacity='.35'/><rect width='18' height='9' fill='#1c1c1c' opacity='.35'/></pattern><pattern id='gingham' width='16' height='16' patternUnits='userSpaceOnUse'><rect width='16' height='16' fill='#fff6f4'/><rect width='8' height='16' fill='#c98d8d' opacity='.35'/><rect width='16' height='8' fill='#c98d8d' opacity='.35'/></pattern><pattern id='candy' width='20' height='20' patternUnits='userSpaceOnUse' patternTransform='rotate(45)'><rect width='20' height='20' fill='#fff8ec'/><rect width='10' height='20' fill='#f2b33d'/></pattern><filter id='wc' x='-30%' y='-30%' width='160%' height='160%'><feTurbulence type='fractalNoise' baseFrequency='.035' numOctaves='2' seed='3'/><feDisplacementMap in='SourceGraphic' scale='26'/><feGaussianBlur stdDeviation='6'/></filter></defs>",
  rose2 = (x, y, r, c1, c2, c3) => {
    let o = "";
    for (let i = 0; i < 6; i++) {
      const a = (i * Math.PI) / 3 + 0.3;
      o += `<circle cx='${f(x + Math.cos(a) * r * 0.5)}' cy='${f(y + Math.sin(a) * r * 0.5)}' r='${f(r * 0.52)}' fill='${c1}'/>`;
    }
    return (
      o +
      `<circle cx='${x}' cy='${y}' r='${f(r * 0.66)}' fill='${c2}'/><path d='M${f(x - r * 0.42)} ${f(y + r * 0.08)}a${f(r * 0.42)} ${f(r * 0.42)} 0 1 1 ${f(r * 0.72)} ${f(r * 0.3)}M${f(x - r * 0.2)} ${f(y - r * 0.02)}a${f(r * 0.22)} ${f(r * 0.22)} 0 1 1 ${f(r * 0.36)} ${f(r * 0.12)}' stroke='${c3}' stroke-width='${f(Math.max(1, r * 0.09))}' fill='none' stroke-linecap='round'/><path d='M${f(x - r * 0.9)} ${f(y + r * 0.1)}q${f(r * 0.2)} ${f(r * 0.6)} ${f(r * 0.8)} ${f(r * 0.7)}M${f(x + r * 0.9)} ${f(y - r * 0.1)}q${f(-r * 0.1)} ${f(r * 0.6)} ${f(-r * 0.7)} ${f(r * 0.8)}' stroke='${c3}' stroke-width='${f(Math.max(0.8, r * 0.06))}' fill='none' opacity='.6'/>`
    );
  },
  peony = (x, y, r, c1, c2) => {
    let o = "";
    for (let i = 0; i < 9; i++)
      o += `<ellipse cx='${x}' cy='${f(y - r * 0.55)}' rx='${f(r * 0.38)}' ry='${f(r * 0.5)}' fill='${c1}' transform='rotate(${i * 40} ${x} ${y})'/>`;
    for (let i = 0; i < 6; i++)
      o += `<ellipse cx='${x}' cy='${f(y - r * 0.3)}' rx='${f(r * 0.26)}' ry='${f(r * 0.34)}' fill='${c2}' transform='rotate(${i * 60 + 20} ${x} ${y})'/>`;
    return (
      o + `<circle cx='${x}' cy='${y}' r='${f(r * 0.16)}' fill='#e8c58a'/>`
    );
  },
  euc = (p0, c, p1, n = 14, len = 20) =>
    leafyBranch(p0, c, p1, {
      n,
      len,
      colors: ["#8da48a", "#a9bba5", "#7d9479", "#b9c8b5"],
      round: !0,
      stem: "#7d9479",
    }),
  pampas = (p0, c, p1, n = 30) =>
    leafyBranch(p0, c, p1, {
      n,
      len: 13,
      wid: 2.6,
      colors: ["#e8d9c0", "#dcc8a8", "#efe3cf"],
      spread: 24,
      stem: "#cdb894",
      start: 0.25,
    }),
  fernLeaf = (p0, c, p1, col, n = 16) =>
    leafyBranch(p0, c, p1, {
      n,
      len: 14,
      wid: 3.4,
      colors: [col],
      spread: 55,
      stem: col,
    }),
  firTree = (x, y, h, front = "#2e5a40", back = "#3c6a4c") => {
    let o = `<rect x='${f(x - h * 0.035)}' y='${f(y - h * 0.1)}' width='${f(h * 0.07)}' height='${f(h * 0.1)}' fill='#5a4630'/>`;
    const tiers = 4;
    for (let k = 0; k < tiers; k++) {
      const y1 = y - h * 0.08 - k * h * 0.2,
        y0 = y1 - h * 0.34,
        w = h * 0.4 * (1 - k * 0.2),
        teeth = 6,
        col = k % 2 ? back : front;
      let d = `M${f(x)} ${f(y0)}L${f(x + w)} ${f(y1)}`;
      for (let i = 1; i <= teeth; i++) {
        const xt = x + w - (2 * w * i) / teeth;
        d += `L${f(xt + w / teeth)} ${f(y1 - h * 0.035)}L${f(xt)} ${f(y1)}`;
      }
      o += `<path d='${d}Z' fill='${col}'/>`;
      const sy = y0 + (y1 - y0) * 0.55,
        sw = w * 0.55;
      o += `<path d='M${f(x - sw)} ${f(sy)}Q${f(x - sw * 0.5)} ${f(sy - h * 0.03)} ${f(x)} ${f(sy - h * 0.02)}Q${f(x + sw * 0.5)} ${f(sy - h * 0.035)} ${f(x + sw)} ${f(sy)}Q${f(x + sw * 0.6)} ${f(sy + h * 0.03)} ${f(x + sw * 0.3)} ${f(sy + h * 0.01)}Q${f(x)} ${f(sy + h * 0.035)} ${f(x - sw * 0.3)} ${f(sy + h * 0.012)}Q${f(x - sw * 0.7)} ${f(sy + h * 0.03)} ${f(x - sw)} ${f(sy)}Z' fill='#fffdf8' opacity='.9'/>`;
    }
    const ty = y - h * 0.08 - (tiers - 1) * h * 0.2 - h * 0.34;
    return (
      o +
      `<path d='M${f(x)} ${f(ty)}L${f(x + h * 0.07)} ${f(ty + h * 0.1)}Q${f(x)} ${f(ty + h * 0.08)} ${f(x - h * 0.07)} ${f(ty + h * 0.1)}Z' fill='#fffdf8'/>`
    );
  },
  lights = (p0, c, p1, n, colors) => {
    let o = curve(p0, c, p1, "#1a2a20", 1.4);
    for (let i = 0; i < n; i++) {
      const t = (i + 0.5) / n,
        [x, y] = quad(p0, c, p1, t),
        col = colors[i % colors.length];
      o += `<circle cx='${f(x)}' cy='${f(y + 9)}' r='9' fill='${col}' opacity='.22'/><rect x='${f(x - 2)}' y='${f(y)}' width='4' height='4' fill='#556b5c'/><ellipse cx='${f(x)}' cy='${f(y + 9)}' rx='3.6' ry='5.4' fill='${col}'/>`;
    }
    return o;
  },
  ballDefs = `<defs>${[
    ["gPink", "#f8c3bd", "#e68a83"],
    ["gPeach", "#fbd9a0", "#ecaa52"],
    ["gAqua", "#c5e2e4", "#7fb3b8"],
    ["gLilac", "#e2d4f0", "#a891cc"],
    ["gGold", "#f6e2a6", "#c9a45c"],
    ["gCoral", "#f9b49f", "#e36f55"],
  ]
    .map(
      ([id, a, b]) =>
        `<radialGradient id='${id}' cx='.35' cy='.3' r='.8'><stop offset='0' stop-color='${a}'/><stop offset='1' stop-color='${b}'/></radialGradient>`,
    )
    .join(
      "",
    )}<linearGradient id='gFoil' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#f8e6ad'/><stop offset='.5' stop-color='#d4af5f'/><stop offset='1' stop-color='#f1d78f'/></linearGradient></defs>`,
  balloon2 = (x, y, r, grad, len = 60, sway = 6) =>
    `<path d='M${x} ${f(y + r * 1.22 + 4)}c${sway} ${f(len * 0.3)} ${-sway} ${f(len * 0.55)} ${f(sway * 0.4)} ${len}' stroke='#b9a79a' stroke-width='1' fill='none'/><path d='M${f(x - 5)} ${f(y + r * 1.26 + 2)}q5 5 10 0q-5 7 -10 0' stroke='#b9a79a' stroke-width='1' fill='none'/><ellipse cx='${x}' cy='${y}' rx='${r}' ry='${f(r * 1.2)}' fill='url(#${grad})'/><path d='M${f(x - 3.5)} ${f(y + r * 1.24)}h7l-3.5 -5z' fill='url(#${grad})'/><ellipse cx='${f(x - r * 0.36)}' cy='${f(y - r * 0.46)}' rx='${f(r * 0.16)}' ry='${f(r * 0.3)}' fill='#fff' opacity='.7' transform='rotate(-25 ${f(x - r * 0.36)} ${f(y - r * 0.46)})'/>`,
  starBalloon = (x, y, r, len = 60) =>
    `<path d='M${x} ${y + r}c-6 ${f(len * 0.3)} 6 ${f(len * 0.6)} 0 ${len}' stroke='#b9a79a' stroke-width='1' fill='none'/>` +
    star5(x, y, r, "url(#gFoil)").replace(
      "/>",
      " stroke='#c9a45c' stroke-width='1' stroke-linejoin='round'/>",
    ) +
    `<path d='M${f(x - r * 0.3)} ${f(y - r * 0.4)}l${f(r * 0.2)} ${f(r * 0.1)}' stroke='#fff' stroke-width='2' stroke-linecap='round' opacity='.8'/>`,
  giftBox = (x, y, s, c, ribbon) =>
    g(
      `<rect x='-26' y='-18' width='52' height='40' rx='2' fill='${c}'/><rect x='-30' y='-28' width='60' height='12' rx='2' fill='${c}' stroke='#00000018'/><rect x='-5' y='-28' width='10' height='50' fill='${ribbon}'/><path d='M0 -28C-6 -44 -24 -46 -22 -36C-20 -28 -8 -28 0 -28ZM0 -28C6 -44 24 -46 22 -36C20 -28 8 -28 0 -28Z' fill='${ribbon}'/><circle cx='0' cy='-29' r='4' fill='${ribbon}'/>`,
      `translate(${x} ${y}) scale(${s})`,
    ),
  cake2 = (x, y, s) =>
    g(
      `<ellipse cx='0' cy='40' rx='52' ry='7' fill='#e6d3b8'/><rect x='-44' y='4' width='88' height='36' rx='5' fill='#f5c6c2'/><rect x='-34' y='-28' width='68' height='34' rx='5' fill='#fbe3d6'/><rect x='-24' y='-54' width='48' height='28' rx='5' fill='#f8d38f'/><path d='M-44 6h88v6q-5 9 -9 0q-5 12 -10 0q-5 8 -10 0q-5 11 -10 0q-5 7 -10 0q-5 12 -10 0q-5 8 -10 0q-5 10 -10 0q-4 8 -9 0z' fill='#fffdf8'/><path d='M-34 -26h68v6q-5 8 -9 0q-5 10 -10 0q-5 7 -10 0q-5 10 -10 0q-5 7 -10 0q-5 9 -10 0q-4 7 -9 0z' fill='#fffdf8'/><path d='M-24 -52h48v5q-4 7 -8 0q-4 8 -8 0q-4 6 -8 0q-4 8 -8 0q-4 6 -8 0q-4 7 -8 0z' fill='#fffdf8'/>${[
        [-30, 24, "#5bb3a8"],
        [-14, 30, "#f0715a"],
        [6, 24, "#7a8cf0"],
        [24, 30, "#f2b33d"],
        [36, 22, "#e77db0"],
        [-20, -10, "#5bb3a8"],
        [0, -6, "#e77db0"],
        [20, -12, "#f0715a"],
        [-10, -38, "#7a8cf0"],
        [10, -40, "#5bb3a8"],
      ]
        .map(
          ([a, b, c], i) =>
            `<rect x='${a}' y='${b}' width='6' height='2.4' rx='1.2' fill='${c}' transform='rotate(${i * 37} ${a + 3} ${b + 1})'/>`,
        )
        .join(
          "",
        )}${[-14, 0, 14].map((a, i) => `<rect x='${a - 2}' y='-74' width='4' height='20' rx='1.5' fill='${["#7a8cf0", "#f0715a", "#5bb3a8"][i]}'/><path d='M${a} -86q5 6 0 10q-5 -4 0 -10z' fill='#f2b33d'/><path d='M${a} -82q2 3 0 5q-2 -2 0 -5z' fill='#fff3c4'/>`).join("")}`,
      `translate(${x} ${y}) scale(${s})`,
    ),
  flagBunting = (p0, c, p1, n, colors, h = 30, w = 28) => {
    let o = curve(p0, c, p1, "#8a7a6a", 1.2);
    for (let i = 0; i < n; i++) {
      const t = (i + 0.5) / n,
        [x, y] = quad(p0, c, p1, t),
        a = quadAngle(p0, c, p1, t),
        col = colors[i % colors.length],
        kind = i % 3,
        deco =
          kind === 0
            ? "<circle cx='-5' cy='6' r='2' fill='#fff' opacity='.8'/><circle cx='5' cy='6' r='2' fill='#fff' opacity='.8'/><circle cx='0' cy='15' r='2' fill='#fff' opacity='.8'/>"
            : kind === 1
              ? `<path d='M${f(-w / 2 + 4)} 5H${f(w / 2 - 4)}M${f(-w / 2 + 8)} 12H${f(w / 2 - 8)}' stroke='#fff' stroke-width='2' opacity='.7'/>`
              : "<path d='M-6 3L0 20L6 3' stroke='#fff' stroke-width='1.4' fill='none' stroke-dasharray='2 2' opacity='.8'/>";
      o += g(
        `<path d='M${f(-w / 2)} 0L${f(w / 2)} 0L0 ${h}Z' fill='${col}'/>${deco}`,
        `translate(${f(x)} ${f(y)}) rotate(${f(a)})`,
      );
    }
    return o;
  },
  curlStreamer = (x, y, len, col, dir = 1) => {
    let d = `M${x} ${y}`;
    for (let i = 0; i < len; i++)
      d += `c${dir * 14} 6 ${dir * 14} 22 0 22c${-dir * 10} 0 ${-dir * 8} -10 0 -6`;
    return `<path d='${d}' stroke='${col}' stroke-width='3' fill='none' stroke-linecap='round'/>`;
  },
  medal = (x, y, s) =>
    g(
      `<path d='M-12 10L-24 52L-14 46L-8 58L2 16Z' fill='#28394d'/><path d='M12 10L24 52L14 46L8 58L-2 16Z' fill='#3b5070'/><circle cx='0' cy='0' r='22' fill='url(#gFoil)' stroke='#b48f45' stroke-width='1.4'/><circle cx='0' cy='0' r='16' fill='none' stroke='#b48f45' stroke-width='1' stroke-dasharray='2 2'/>${star5(0, 0, 9, "#b48f45")}`,
      `translate(${x} ${y}) scale(${s})`,
    ),
  capTossed = (x, y, s, ang) =>
    mortarboard(x, y, s, "#28394d", "#c9a45c", ang) +
    `<path d='M${x - 40 * s} ${y + 34 * s}q-6 10 -2 18M${x - 20 * s} ${y + 40 * s}q-4 10 0 16' stroke='#c9a45c' stroke-width='1.2' fill='none' opacity='.7' stroke-linecap='round'/>`,
  goldSprig = (p0, c, p1, n = 10) =>
    leafyBranch(p0, c, p1, {
      n,
      len: 15,
      wid: 4.5,
      colors: ["#c9a45c", "#d8b974", "#b8944f"],
      spread: 40,
      stem: "#c9a45c",
    }),
  cloud2 = (x, y, s, fill = "#fff", shade = "#d9e5ec") =>
    g(
      `<g fill='${shade}' transform='translate(3 5)'><circle cx='-26' cy='4' r='14'/><circle cx='-8' cy='-8' r='18'/><circle cx='14' cy='-4' r='16'/><circle cx='30' cy='6' r='11'/><rect x='-40' y='4' width='80' height='14' rx='7'/></g><g fill='${fill}'><circle cx='-26' cy='4' r='14'/><circle cx='-8' cy='-8' r='18'/><circle cx='14' cy='-4' r='16'/><circle cx='30' cy='6' r='11'/><rect x='-40' y='4' width='80' height='14' rx='7'/></g><path d='M-14 -16q6 -6 14 -2' stroke='#fff' stroke-width='3' fill='none' stroke-linecap='round' opacity='.9'/>`,
      `translate(${x} ${y}) scale(${s})`,
    ),
  hotAir2 = (x, y, s) =>
    g(
      "<path d='M0 -64C-34 -64 -42 -30 -30 -6C-22 10 -10 18 -8 26H8C10 18 22 10 30 -6C42 -30 34 -64 0 -64Z' fill='#f2b8b8'/><path d='M0 -64C-18 -64 -24 -30 -16 -6C-12 10 -6 18 -5 26H5C6 18 12 10 16 -6C24 -30 18 -64 0 -64Z' fill='#fdf3ea'/><path d='M0 -64C-6 -64 -9 -30 -6 -6C-4 10 -2 18 -2 26H2C2 18 4 10 6 -6C9 -30 6 -64 0 -64Z' fill='#9bb3c4'/><path d='M-30 -6Q0 4 30 -6' stroke='#e9a8a8' stroke-width='2' fill='none'/><path d='M-8 26L-7 38M8 26L7 38' stroke='#b49a7a' stroke-width='1.2'/><rect x='-9' y='38' width='18' height='13' rx='2' fill='#c4a07a'/><path d='M-9 42H9' stroke='#a88560' stroke-width='1'/>",
      `translate(${x} ${y}) scale(${s})`,
    ),
  crescent = (x, y, r, fill, bg) =>
    `<circle cx='${x}' cy='${y}' r='${r}' fill='${fill}'/><circle cx='${f(x + r * 0.5)}' cy='${f(y - r * 0.35)}' r='${f(r * 0.88)}' fill='${bg}'/>`,
  kraftTag = (x, y, s, ang) =>
    g(
      `<path d='M0 -40V-14' stroke='#a88560' stroke-width='1.8'/><path d='M-16 -14H16V26H-16V-6Z' fill='#e9d8b8' stroke='#b49a7a' stroke-width='1'/><path d='M-16 -14L-16 -4L-6 -14Z' fill='#d9c29e'/><circle cx='0' cy='-6' r='2.6' fill='#d9c29e' stroke='#b49a7a' stroke-width='.8'/>${heart(0, 10, 0.75, "#c27c6a")}`,
      `translate(${x} ${y}) rotate(${ang}) scale(${s})`,
    ),
  wheat = (x, y, h, ang, c = "#e8d4a8") =>
    g(
      `<path d='M0 0V${-h}' stroke='${c}' stroke-width='1.4'/>${Array.from({ length: 6 }, (_, i) => `<ellipse cx='-3' cy='${f(-h + 6 + i * 6)}' rx='2.4' ry='4.6' fill='${c}' transform='rotate(-25 -3 ${f(-h + 6 + i * 6)})'/><ellipse cx='3' cy='${f(-h + 9 + i * 6)}' rx='2.4' ry='4.6' fill='${c}' transform='rotate(25 3 ${f(-h + 9 + i * 6)})'/>`).join("")}`,
      `translate(${x} ${y}) rotate(${ang})`,
    ),
  cornflower = (x, y, r) => {
    let o = "";
    for (let i = 0; i < 8; i++)
      o += `<path d='M${x} ${y}l${f(-r * 0.25)} ${f(-r)}l${f(r * 0.25)} ${f(-r * 0.15)}l${f(r * 0.25)} ${f(r * 0.15)}z' fill='#6f8fcf' transform='rotate(${i * 45} ${x} ${y})'/>`;
    return (
      o + `<circle cx='${x}' cy='${y}' r='${f(r * 0.25)}' fill='#3f5aa0'/>`
    );
  },
  buttercup = (x, y, r) => flower5(x, y, r, "#f2cf5b", "#d99a2b"),
  lineLeaf = (x, y, s, ang, c = "#4a4b36") =>
    g(
      `<path d='M0 0C10 -18 34 -24 56 -18C46 2 24 10 0 0Z' fill='none' stroke='${c}' stroke-width='1.4'/><path d='M0 0Q26 -10 52 -17M16 -6l6 -10M28 -10l7 -9M40 -13l6 -6M16 -6l10 6M28 -10l10 5' stroke='${c}' stroke-width='1' fill='none' stroke-linecap='round'/>`,
      `translate(${x} ${y}) rotate(${ang}) scale(${s})`,
    ),
  bow = (x, y, s, fill, stroke) =>
    g(
      `<path d='M-4 8L-30 58L-18 51L-11 63L6 12Z' fill='${fill}' stroke='${stroke}' stroke-width='1.3'/><path d='M4 8L30 58L18 51L11 63L-6 12Z' fill='${fill}' stroke='${stroke}' stroke-width='1.3'/><path d='M0 0C-12 -32 -56 -36 -56 -7C-56 17 -20 19 0 0Z' fill='${fill}' stroke='${stroke}' stroke-width='1.5'/><path d='M0 0C12 -32 56 -36 56 -7C56 17 20 19 0 0Z' fill='${fill}' stroke='${stroke}' stroke-width='1.5'/><rect x='-9' y='-10' width='18' height='20' rx='5' fill='${fill}' stroke='${stroke}' stroke-width='1.5'/>`,
      `translate(${x} ${y}) scale(${s})`,
    ),
  ART = {
    "std-botanical": svgURL(
      ballDefs +
        "<rect x='14' y='14' width='472' height='672' rx='3' fill='none' stroke='#a9bba5' stroke-width='1'/>" +
        rings(250, 30, 8, "#b49a62") +
        g(
          euc([-8, -4], [70, 10], [200, 6], 16, 22) +
            euc([-4, -8], [10, 90], [8, 230], 16, 22) +
            euc([-4, -4], [60, 50], [118, 112], 9, 18) +
            leafyBranch([-4, 40], [60, 30], [150, 50], {
              n: 10,
              len: 16,
              wid: 4,
              colors: ["#9fb39b", "#b7c4aa"],
              spread: 48,
              stem: "#9fb39b",
            }) +
            rose2(56, 54, 24, "#f6e6df", "#efd3c8", "#d1a593") +
            rose2(100, 28, 15, "#fffdf8", "#f3ebe3", "#d8c6b6") +
            rose2(24, 104, 15, "#f3d9cf", "#e9c3b5", "#c99c88") +
            flower5(132, 46, 7, "#fffdf8", "#d8b7a8") +
            flower5(40, 150, 6, "#fffdf8", "#d8b7a8") +
            "<circle cx='86' cy='70' r='4' fill='#e9c3b5'/><circle cx='150' cy='22' r='3.4' fill='#e9c3b5'/>",
          "translate(4 4) scale(.98)",
        ) +
        g(
          euc([-8, -4], [70, 10], [200, 6], 16, 22) +
            euc([-4, -8], [10, 90], [8, 230], 16, 22) +
            euc([-4, -4], [60, 50], [118, 112], 9, 18) +
            rose2(56, 54, 24, "#f6e6df", "#efd3c8", "#d1a593") +
            rose2(100, 28, 15, "#fffdf8", "#f3ebe3", "#d8c6b6") +
            rose2(24, 104, 15, "#f3d9cf", "#e9c3b5", "#c99c88") +
            flower5(132, 46, 7, "#fffdf8", "#d8b7a8"),
          "translate(494 694) scale(-1.05 -1.05)",
        ) +
        scatter(
          [
            [200, 30, 4],
            [300, 30, 4],
            [460, 90, 3.5],
            [40, 610, 3.5],
          ],
          (x, y, s) => sparkle(x, y, s, "#c9a45c", 0.85),
        ),
    ),
    "std-black-gold": svgURL(
      ballDefs +
        "<rect x='16' y='16' width='468' height='668' fill='none' stroke='#c9a45c' stroke-width='1.6'/><rect x='25' y='25' width='450' height='650' fill='none' stroke='#c9a45c' stroke-width='.9'/>" +
        decoFan(25, 25, 70, 0, "#c9a45c") +
        decoFan(475, 25, 70, 90, "#c9a45c") +
        decoFan(475, 675, 70, 180, "#c9a45c") +
        decoFan(25, 675, 70, 270, "#c9a45c") +
        "<g stroke='#c9a45c' stroke-width='1' fill='none'><path d='M34 110V34H110M466 110V34H390M34 590V666H110M466 590V666H390'/><path d='M250 20l8 8l-8 8l-8 -8z' fill='#171717'/><path d='M250 664l8 8l-8 8l-8 -8z' fill='#171717'/></g>" +
        rings(250, 50, 9, "#c9a45c") +
        goldSprig([232, 52], [200, 40], [150, 50], 9) +
        goldSprig([268, 52], [300, 40], [350, 50], 9) +
        scatter(
          [
            [56, 330, 6],
            [444, 330, 6],
            [60, 364, 3],
            [440, 364, 3],
            [130, 64, 3],
            [370, 64, 3],
          ],
          (x, y, s) => sparkle(x, y, s, "#c9a45c", 0.9),
        ),
    ),
    "std-blush-arch": svgURL(
      ballDefs +
        "<path d='M62 700V500A188 188 0 0 1 438 500V700' fill='none' stroke='#c9a45c' stroke-width='1.3' opacity='.8'/><path d='M76 700V506A174 174 0 0 1 424 506V700Z' fill='#eac9b8'/>" +
        g(
          pampas([0, 0], [-30, -50], [-48, -130]) +
            pampas([0, 0], [-50, -30], [-110, -60]) +
            pampas([0, 0], [10, -60], [6, -120], 24) +
            euc([0, 0], [40, -10], [80, -50], 8, 18) +
            euc([0, 0], [-20, 30], [-50, 60], 7, 16) +
            rose2(-6, 4, 24, "#e3a493", "#d58c78", "#b0664f") +
            rose2(28, -16, 17, "#f6e6df", "#efd3c8", "#d1a593") +
            rose2(-30, -20, 15, "#c9775e", "#b5634b", "#8f4532") +
            rose2(18, 22, 13, "#fffdf8", "#f3ebe3", "#d8c6b6") +
            flower5(-34, 18, 7, "#fffdf8", "#d8b7a8"),
          "translate(100 404) scale(1.2)",
        ) +
        g(
          pampas([0, 0], [30, -50], [48, -120]) +
            euc([0, 0], [-40, -10], [-76, -46], 7, 16) +
            rose2(4, 2, 19, "#e3a493", "#d58c78", "#b0664f") +
            rose2(-24, -12, 13, "#f6e6df", "#efd3c8", "#d1a593") +
            flower5(22, 18, 6, "#fffdf8", "#d8b7a8"),
          "translate(402 416) scale(1.15)",
        ) +
        g(
          pampas([0, 0], [20, 30], [70, 40], 18) +
            pampas([0, 0], [30, 14], [90, 6], 18) +
            rose2(14, 14, 10, "#f3d9cf", "#e9c3b5", "#c99c88"),
          "translate(6 8)",
        ) +
        g(
          pampas([0, 0], [20, 30], [70, 40], 18) +
            pampas([0, 0], [30, 14], [90, 6], 18) +
            rose2(14, 14, 10, "#f3d9cf", "#e9c3b5", "#c99c88"),
          "translate(494 8) scale(-1 1)",
        ),
    ),
    "xmas-plaid": svgURL(
      "<defs><pattern id='bplaid' width='24' height='24' patternUnits='userSpaceOnUse'><rect width='24' height='24' fill='#a3202f'/><rect width='12' height='24' fill='#1a1414' opacity='.42'/><rect width='24' height='12' fill='#1a1414' opacity='.42'/><path d='M0 6H24M6 0V24' stroke='#d8505c' stroke-width='.6' opacity='.35'/></pattern></defs><rect width='500' height='700' fill='url(#bplaid)'/><rect x='13' y='13' width='474' height='674' rx='4' fill='none' stroke='#fffdf8' stroke-width='1.2' stroke-dasharray='6 5' opacity='.55'/><rect x='24' y='24' width='452' height='652' rx='8' fill='#fbf7f0'/>" +
        firSprig([250, 44], [180, 68], [96, 48], 26) +
        firSprig([250, 44], [320, 68], [404, 48], 26) +
        firSprig([250, 48], [200, 80], [150, 80], 14) +
        firSprig([250, 48], [300, 80], [350, 80], 14) +
        hollyLeaf2(250, 54, 0.95, 160, "#3f6e47") +
        hollyLeaf2(250, 54, 0.95, 20, "#2b5235") +
        berries(226, 62, 5.5) +
        berries(266, 62, 5) +
        plaidBow(250, 44, 1.05) +
        firSprig([24, 676], [60, 650], [118, 646], 14) +
        firSprig([24, 676], [36, 640], [42, 590], 14) +
        hollyLeaf2(26, 674, 0.8, -40, "#2b5235") +
        berries(44, 652, 5) +
        firSprig([476, 676], [440, 650], [382, 646], 14) +
        firSprig([476, 676], [464, 640], [458, 590], 14) +
        hollyLeaf2(474, 674, 0.8, 220, "#2b5235") +
        berries(448, 652, 5) +
        scatter(
          [
            [70, 112, 4],
            [430, 112, 4],
            [56, 250, 3.5],
            [444, 250, 3.5],
            [60, 420, 3],
            [440, 420, 3],
          ],
          (x, y, s) => sparkle(x, y, s, "#c9a45c", 0.9),
        ),
    ),
    "xmas-evergreen": svgURL(
      lights([-10, 14], [250, 70], [510, 14], 15, [
        "#f2c94c",
        "#e2574c",
        "#7fc79a",
        "#f2c94c",
        "#6fa8dc",
      ]) +
        scatter(
          [
            [50, 120, 14],
            [452, 110, 16],
            [30, 260, 10],
            [470, 250, 11],
            [56, 400, 8],
            [446, 410, 9],
          ],
          (x, y, s) => snowflake(x, y, s, "#fffdf8", 0.7),
        ) +
        scatter(
          [
            [100, 90],
            [400, 96],
            [140, 150],
            [360, 140],
            [80, 200],
            [430, 190],
            [24, 330],
            [478, 330],
            [70, 470],
            [436, 460],
            [110, 300],
            [390, 300],
            [200, 110],
            [300, 112],
            [60, 540],
            [450, 540],
          ],
          (x, y, s, i) =>
            `<circle cx='${x}' cy='${y}' r='${i % 3 ? 1.8 : 2.6}' fill='#fffdf8' opacity='.6'/>`,
        ) +
        "<path d='M0 700V640Q50 618 110 636Q170 650 230 642T360 636Q430 618 500 640V700Z' fill='#e9efe9'/><path d='M0 700V660Q70 646 140 660T300 662T500 656V700Z' fill='#fffdf8'/>" +
        firTree(46, 652, 150, "#2e5a40", "#3c6a4c") +
        firTree(108, 664, 100, "#3c6a4c", "#4a7a5a") +
        firTree(456, 652, 150, "#2e5a40", "#3c6a4c") +
        firTree(394, 664, 100, "#3c6a4c", "#4a7a5a") +
        star5(46, 494, 10, "#f2c94c") +
        "<circle cx='46' cy='494' r='16' fill='#f2c94c' opacity='.18'/>" +
        star5(456, 494, 10, "#f2c94c") +
        "<circle cx='456' cy='494' r='16' fill='#f2c94c' opacity='.18'/>",
    ),
    "xmas-holly": svgURL(
      hollyCorner() +
        g(hollyCorner(), "translate(500 0) scale(-1 1)") +
        g(hollyCorner(!0), "translate(0 700) scale(.8 -.8)") +
        g(hollyCorner(!0), "translate(500 700) scale(-.8 -.8)") +
        scatter(
          [
            [180, 26, 5],
            [320, 26, 5],
            [250, 14, 3.5],
            [44, 250, 4],
            [456, 250, 4],
            [60, 330, 3],
            [440, 330, 3],
          ],
          (x, y, s) => sparkle(x, y, s, "#c9a45c", 0.85),
        ),
    ),
    "bday-confetti": svgURL(
      ballDefs +
        flagBunting(
          [-10, 6],
          [250, 54],
          [510, 6],
          13,
          ["#f0715a", "#f2b33d", "#5bb3a8", "#7a8cf0", "#e77db0"],
          32,
          32,
        ) +
        curlStreamer(36, 96, 4, "#7a8cf0", 1) +
        curlStreamer(464, 96, 4, "#f2b33d", -1) +
        curlStreamer(30, 470, 3, "#e77db0", 1) +
        curlStreamer(470, 460, 3, "#5bb3a8", -1) +
        confettiAt(
          [
            [20, 70],
            [480, 80],
            [70, 120],
            [430, 124],
            [16, 200],
            [486, 210],
            [80, 250],
            [420, 260],
            [22, 330],
            [478, 340],
            [78, 380],
            [422, 390],
            [18, 440],
            [482, 440],
            [60, 560],
            [440, 560],
            [24, 610],
            [476, 610],
            [70, 660],
            [430, 660],
            [110, 690],
            [390, 690],
            [150, 676],
            [350, 676],
            [96, 610],
            [404, 610],
            [46, 520],
            [454, 520],
          ],
          ["#f0715a", "#f2b33d", "#5bb3a8", "#7a8cf0", "#e77db0"],
        ) +
        scatter(
          [
            [150, 84, 5],
            [350, 84, 5],
            [100, 160, 4],
            [400, 170, 4],
            [40, 600, 5],
            [460, 600, 5],
          ],
          (x, y, s) => sparkle(x, y, s, "#d4af5f"),
        ),
    ),
    "bday-balloons": svgURL(
      ballDefs +
        balloon2(40, 48, 24, "gPink", 70, 6) +
        balloon2(88, 34, 19, "gPeach", 60, -5) +
        balloon2(132, 44, 15, "gLilac", 50, 4) +
        balloon2(22, 118, 15, "gAqua", 120, 5) +
        balloon2(64, 100, 12, "gCoral", 80, -4) +
        starBalloon(460, 46, 28, 70) +
        balloon2(406, 34, 18, "gAqua", 60, 5) +
        balloon2(368, 44, 14, "gPink", 50, -4) +
        balloon2(478, 120, 14, "gPeach", 120, -5) +
        balloon2(436, 100, 12, "gLilac", 80, 4) +
        scatter(
          [
            [170, 26, 6],
            [330, 26, 6],
            [190, 70, 4],
            [312, 70, 4],
            [30, 330, 5],
            [470, 330, 5],
            [56, 440, 4],
            [444, 440, 4],
          ],
          (x, y, s) => sparkle(x, y, s, "#d4af5f"),
        ) +
        confettiAt(
          [
            [30, 420],
            [470, 430],
            [50, 500],
            [450, 510],
            [24, 580],
            [476, 590],
            [64, 650],
            [436, 650],
            [110, 684],
            [390, 684],
          ],
          ["#f0715a", "#5bb3a8", "#f2b33d", "#e77db0"],
        ) +
        balloon2(470, 560, 16, "gCoral", 90, -6) +
        balloon2(32, 546, 14, "gAqua", 90, 6),
    ),
    "bday-stripes": svgURL(
      patterns +
        ballDefs +
        "<path d='M0 0H500V700H0ZM21 21V679H479V21Z' fill='url(#candy)' fill-rule='evenodd'/><rect x='21' y='21' width='458' height='658' fill='none' stroke='#e39b1f' stroke-width='1.2'/>" +
        flagBunting(
          [21, 30],
          [250, 74],
          [479, 30],
          9,
          ["#f0715a", "#5bb3a8", "#7a8cf0", "#e77db0"],
          26,
          30,
        ) +
        cake2(86, 612, 0.9) +
        giftBox(430, 640, 0.9, "#7a8cf0", "#f2b33d") +
        giftBox(462, 652, 0.6, "#f0715a", "#5bb3a8") +
        scatter(
          [
            [50, 160],
            [450, 160],
            [44, 240],
            [456, 240],
            [60, 320],
            [440, 320],
            [44, 400],
            [456, 400],
            [440, 480],
            [50, 480],
            [140, 664],
            [360, 664],
            [450, 560],
            [52, 540],
          ],
          (x, y, s, i) =>
            `<rect x='${x - 5}' y='${y - 1.6}' width='10' height='3.2' rx='1.6' fill='${["#f0715a", "#5bb3a8", "#7a8cf0", "#e77db0", "#f2b33d"][i % 5]}' transform='rotate(${(i * 67) % 180} ${x} ${y})'/>`,
        ) +
        scatter(
          [
            [120, 110, 5],
            [380, 110, 5],
          ],
          (x, y, s) => sparkle(x, y, s, "#e39b1f"),
        ),
    ),
    "grad-navy-gold": svgURL(
      ballDefs +
        "<rect x='18' y='18' width='464' height='664' fill='none' stroke='#c9a45c' stroke-width='1.8'/><rect x='26' y='26' width='448' height='648' fill='none' stroke='#c9a45c' stroke-width='.8' opacity='.7'/>" +
        goldSprig([222, 70], [170, 66], [120, 40], 11) +
        goldSprig([278, 70], [330, 66], [380, 40], 11) +
        mortarboard(250, 52, 0.85, "#0f1826", "#d4af5f") +
        scatter(
          [
            [60, 70, 9],
            [440, 70, 9],
            [90, 120, 5],
            [410, 120, 5],
            [50, 190, 6],
            [450, 190, 6],
            [60, 300, 4],
            [440, 300, 4],
            [450, 560, 6],
            [60, 470, 4],
            [440, 470, 4],
          ],
          (x, y, s) => star5(x, y, s, "#c9a45c", 0.9),
        ) +
        diploma(84, 612, 1, -22, "#c9a45c") +
        medal(108, 640, 0.55) +
        scatter(
          [
            [150, 40, 4],
            [350, 40, 4],
            [250, 112, 3],
          ],
          (x, y, s) => sparkle(x, y, s, "#d4af5f"),
        ),
    ),
    "grad-pennant": svgURL(
      ballDefs +
        bunting(
          [-10, 10],
          [250, 56],
          [510, 10],
          11,
          ["#28394d", "#c9a45c"],
          36,
          36,
        ) +
        scatter(
          [
            [23, 22],
            [114, 36],
            [205, 44],
            [295, 44],
            [386, 36],
            [477, 22],
          ],
          (x, y) => star5(x, y + 12, 5, "#fffdf8"),
        ) +
        capTossed(56, 236, 0.6, -20) +
        capTossed(450, 214, 0.52, 16) +
        "<path d='M30 320c12 10 -6 22 6 34s-8 24 4 34' stroke='#c9a45c' stroke-width='2.4' fill='none' stroke-linecap='round'/><path d='M470 320c-12 10 6 22 -6 34s8 24 -4 34' stroke='#28394d' stroke-width='2.4' fill='none' stroke-linecap='round'/>" +
        diploma(428, 622, 1, -24, "#28394d") +
        medal(462, 600, 0.5) +
        scatter(
          [
            [40, 140, 6],
            [462, 130, 6],
            [30, 450, 5],
            [470, 450, 5],
            [60, 560, 7],
            [24, 640, 4],
            [90, 650, 5],
          ],
          (x, y, s) => star5(x, y, s, "#c9a45c", 0.85),
        ) +
        scatter(
          [
            [100, 120],
            [400, 120],
            [70, 520],
            [430, 520],
          ],
          (x, y) => sparkle(x, y, 4, "#c9a45c"),
        ),
    ),
    "grad-laurel": svgURL(
      ballDefs +
        leafyBranch([234, 318], [14, 320], [52, 64], {
          n: 22,
          len: 24,
          wid: 7,
          colors: ["#b9a46a", "#8f8a4e", "#cdbb85", "#a39258"],
          spread: 42,
          stem: "#8f8a4e",
          start: 0.03,
        }) +
        leafyBranch([266, 318], [486, 320], [448, 64], {
          n: 22,
          len: 24,
          wid: 7,
          colors: ["#b9a46a", "#8f8a4e", "#cdbb85", "#a39258"],
          spread: 42,
          stem: "#8f8a4e",
          start: 0.03,
        }) +
        scatter(
          [
            [70, 210],
            [82, 150],
            [428, 210],
            [418, 150],
            [110, 286],
            [390, 286],
          ],
          (x, y) =>
            `<circle cx='${x}' cy='${y}' r='3.4' fill='#c9a45c'/><circle cx='${x + 5}' cy='${y + 4}' r='2.6' fill='#d8b974'/>`,
        ) +
        medal(250, 318, 0.9) +
        mortarboard(250, 30, 0.55, "#28394d", "#c9a45c") +
        scatter(
          [
            [40, 470, 5],
            [460, 470, 5],
            [56, 560, 7],
            [444, 560, 7],
            [30, 640, 4],
            [470, 640, 4],
          ],
          (x, y, s) => star5(x, y, s, "#b9a46a"),
        ),
    ),
    "baby-clouds": svgURL(
      ballDefs +
        crescent(54, 50, 28, "#f6dc8e", "#eaf1f5") +
        g(
          "<path d='M-60 0H60' stroke='#b9c7cf' stroke-width='1.6' stroke-linecap='round'/><path d='M-50 0V34M-18 0V52M16 0V40M50 0V58' stroke='#b9c7cf' stroke-width='1'/>" +
            star5(-50, 42, 9, "#f2d07a") +
            crescent(-18, 62, 10, "#f6dc8e", "#eaf1f5") +
            heart(16, 50, 0.8, "#f2b8b8") +
            "<circle cx='50' cy='66' r='7' fill='#bcd3df'/><path d='M0 0V-14' stroke='#b9c7cf' stroke-width='1'/>",
          "translate(250 16) scale(.9)",
        ) +
        cloud2(446, 56, 1.05) +
        cloud2(52, 230, 0.62) +
        cloud2(468, 214, 0.5) +
        hotAir2(458, 370, 1) +
        scatter(
          [
            [130, 24, 6],
            [370, 26, 5],
            [24, 150, 5],
            [470, 290, 5],
            [36, 340, 4],
            [474, 120, 4],
            [110, 90, 3],
            [390, 96, 3],
          ],
          (x, y, s) => sparkle(x, y, s, "#f2d07a"),
        ) +
        "<path d='M0 700V612Q34 590 70 606Q96 578 136 600Q176 582 214 606Q252 588 290 608Q330 584 366 604Q404 580 440 602Q470 588 500 600V700Z' fill='#d9e5ec'/><path d='M0 700V628Q40 608 80 622Q110 598 150 618Q200 602 236 626Q276 606 316 624Q356 598 396 620Q436 600 470 618Q488 610 500 614V700Z' fill='#fff'/>",
    ),
    "baby-watercolor": svgURL(
      patterns +
        "<g filter='url(#wc)' opacity='.6'><circle cx='40' cy='40' r='100' fill='#efc4c4'/><circle cx='480' cy='110' r='70' fill='#f4dabe'/><circle cx='470' cy='650' r='110' fill='#c7d9df'/><circle cx='20' cy='640' r='80' fill='#ddd0ea'/></g>" +
        g(
          leafyBranch([-6, -6], [60, 10], [170, 10], {
            n: 12,
            len: 18,
            wid: 6,
            colors: ["#a9b79c", "#c1cbb4"],
            spread: 48,
            stem: "#9aa88c",
          }) +
            leafyBranch([-6, -6], [10, 60], [8, 170], {
              n: 12,
              len: 18,
              wid: 6,
              colors: ["#a9b79c", "#c1cbb4"],
              spread: 48,
              stem: "#9aa88c",
            }) +
            peony(52, 50, 30, "#f3c9c9", "#f8dede") +
            rose2(104, 26, 15, "#fbe7e2", "#f6d9d2", "#d99a9a") +
            rose2(22, 106, 14, "#fffbf8", "#f8ece6", "#d9b4a8") +
            flower5(130, 54, 8, "#fbe7e2", "#d99a9a") +
            "<circle cx='86' cy='82' r='5' fill='#f3c9c9'/><circle cx='140' cy='20' r='4' fill='#f3c9c9'/>",
          "translate(16 14) scale(1.1)",
        ) +
        g(
          leafyBranch([-6, -6], [60, 10], [170, 10], {
            n: 12,
            len: 18,
            wid: 6,
            colors: ["#a9b79c", "#c1cbb4"],
            spread: 48,
            stem: "#9aa88c",
          }) +
            leafyBranch([-6, -6], [10, 60], [8, 170], {
              n: 12,
              len: 18,
              wid: 6,
              colors: ["#a9b79c", "#c1cbb4"],
              spread: 48,
              stem: "#9aa88c",
            }) +
            peony(52, 50, 30, "#c9dbe3", "#e0ecf0") +
            rose2(104, 26, 15, "#fbe7e2", "#f6d9d2", "#d99a9a") +
            rose2(22, 106, 14, "#fffbf8", "#f8ece6", "#d9b4a8"),
          "translate(486 688) scale(-1.05 -1.05)",
        ) +
        scatter(
          [
            [440, 40, 0.8],
            [470, 74, 0.55],
            [30, 560, 0.7],
            [64, 600, 0.5],
            [180, 30, 0.5],
            [320, 34, 0.45],
          ],
          (x, y, s) => heart(x, y, s, "#e9a8a8", 0.8),
        ),
    ),
    "baby-gingham": svgURL(
      patterns +
        `<path d='M0 0H500V44${Array.from({ length: 13 }, (_, i) => `A19.2 14 0 0 1 ${f(500 - (i + 1) * 38.46)} 44`).join("")}V0Z' fill='url(#gingham)'/><path d='M0 44${Array.from({ length: 13 }, (_, i) => `A19.2 14 0 0 0 ${f((i + 1) * 38.46)} 44`).join("")}' fill='none' stroke='#c98d8d' stroke-width='1' opacity='.7'/>` +
        bow(250, 46, 0.9, "#ebb5b5", "#c98080") +
        "<rect y='688' width='500' height='12' fill='url(#gingham)'/>" +
        duck(70, 626, 1.1) +
        "<path d='M18 664Q70 650 122 664' stroke='#9bb3c4' stroke-width='2' fill='none' opacity='.6'/>" +
        scatter(
          [
            [30, 590, 5],
            [44, 574, 3.4],
            [118, 600, 4],
          ],
          (x, y, s) =>
            `<circle cx='${x}' cy='${y}' r='${s}' fill='none' stroke='#9bb3c4' stroke-width='1.2'/>`,
        ) +
        footprint(430, 600, 1, 14, "#e2b3b3") +
        footprint(462, 642, 1, 22, "#e2b3b3") +
        scatter(
          [
            [40, 100, 0.7],
            [462, 96, 0.9],
            [36, 180, 0.5],
            [470, 200, 0.6],
            [30, 480, 0.6],
            [470, 500, 0.7],
          ],
          (x, y, s, i) => heart(x, y, s, i % 2 ? "#e9a8a8" : "#b9cbd6", 0.9),
        ) +
        scatter(
          [
            [110, 90, 5],
            [390, 90, 5],
            [60, 300, 4],
            [440, 300, 4],
          ],
          (x, y, s) => sparkle(x, y, s, "#f2d07a"),
        ),
    ),
    "ty-kraft": svgURL(
      "<rect x='17' y='17' width='466' height='666' rx='5' fill='none' stroke='#fffdf8' stroke-width='2.4' stroke-dasharray='9 7'/><path d='M-4 28Q250 44 504 28' stroke='#a88560' stroke-width='2.4' fill='none'/>" +
        twineBow(250, 38, 1) +
        kraftTag(70, 70, 1, -8) +
        kraftTag(430, 70, 0.85, 10) +
        scatter(
          [
            [52, 170, 1],
            [450, 180, 1.1],
            [456, 560, 0.9],
          ],
          (x, y, s, i) =>
            `<path d='M0 -3C0 -9 -9 -10 -9 -3C-9 3 0 7 0 10C0 7 9 3 9 -3C9 -10 0 -9 0 -3Z' fill='none' stroke='#fffdf8' stroke-width='1.8' transform='translate(${x} ${y}) rotate(${i % 2 ? 12 : -10}) scale(${s})'/>`,
        ) +
        scatter(
          [
            [110, 130],
            [390, 136],
            [60, 300],
            [440, 320],
            [80, 480],
            [420, 470],
          ],
          (x, y) =>
            `<path d='M${x - 5} ${y}h10M${x} ${y - 5}v10' stroke='#fffdf8' stroke-width='1.8' stroke-linecap='round'/>`,
        ) +
        g(
          wheat(-14, 0, 90, -24) +
            wheat(-4, 0, 100, -12) +
            lavender(4, 0, 84, "#9c86c4") +
            lavender(12, 0, 74, "#b4a1d6") +
            wheat(18, 0, 86, 10) +
            "<path d='M0 0Q4 30 -10 70M8 0Q10 34 18 66' stroke='#9aa678' stroke-width='1.4' fill='none'/>" +
            daisy(-30, -70, 9) +
            daisy(24, -82, 8) +
            daisy(-6, -96, 7) +
            "<path d='M-10 18Q4 26 20 16' stroke='#a88560' stroke-width='3' fill='none'/>" +
            twineBow(4, 22, 0.6),
          "translate(78 640) rotate(-8)",
        ),
    ),
    "ty-wildflowers": svgURL(
      g(
        grass(10, 0, 76, 6) +
          grass(22, 0, 96, 14) +
          grass(40, 0, 66, -8) +
          grass(64, 0, 86, 10) +
          grass(90, 0, 56, -6) +
          grass(120, 0, 44, 8) +
          grass(140, 0, 30, -4) +
          stem(30, 0, 26, -150, 8) +
          daisy(26, -150, 15) +
          stem(58, 0, 72, -110, -6) +
          poppy(72, -112, 13) +
          stem(12, 0, 10, -86, 4) +
          lavender(10, -86, 54) +
          stem(88, 0, 98, -66, 6) +
          cornflower(98, -66, 10) +
          lavender(44, -60, 44, "#b4a1d6") +
          stem(114, 0, 122, -34, 4) +
          daisy(122, -36, 10) +
          stem(48, 0, 46, -124, 2) +
          buttercup(46, -124, 8) +
          stem(134, 0, 146, -52, -4) +
          buttercup(146, -52, 7) +
          stem(70, 0, 52, -190, 10) +
          flower5(52, -190, 9, "#c9a0c8", "#8a6a3d"),
        "translate(0 700)",
      ) +
        g(
          grass(10, 0, 76, 6) +
            grass(22, 0, 96, 14) +
            grass(40, 0, 66, -8) +
            grass(64, 0, 86, 10) +
            grass(90, 0, 56, -6) +
            grass(120, 0, 44, 8) +
            stem(30, 0, 26, -140, 8) +
            daisy(26, -140, 15) +
            stem(58, 0, 72, -100, -6) +
            poppy(72, -102, 12) +
            stem(12, 0, 10, -80, 4) +
            lavender(10, -80, 50) +
            stem(88, 0, 98, -60, 6) +
            cornflower(98, -60, 10) +
            stem(46, 0, 48, -116, 2) +
            buttercup(48, -116, 8) +
            stem(110, 0, 122, -30, 4) +
            daisy(122, -32, 9),
          "translate(500 700) scale(-1 1)",
        ) +
        g(
          stem(0, 0, 40, -10, -6) +
            stem(0, 0, 30, 30, 6) +
            flower5(40, -10, 8, "#f2cf5b", "#d99a2b") +
            daisy(30, 30, 9) +
            cornflower(8, 46, 7) +
            leaf(16, 6, 16, 5, -20, "#9aa678") +
            leaf(14, 16, 16, 5, 40, "#9aa678"),
          "translate(-6 40)",
        ) +
        butterfly(452, 74, 0.95, "#e2a27f", "#f2d07a", 14) +
        butterfly(470, 190, 0.55, "#6f8fcf", "#c5d3ef", -10) +
        butterfly(36, 190, 0.6, "#c9a0c8", "#e9d4ea", -18) +
        bee(110, 56, 0.9, -10) +
        "<path d='M124 62q20 -10 30 6t26 -4' stroke='#8a7a6a' stroke-width='1' fill='none' stroke-dasharray='2 4'/>",
    ),
    "ty-color-block": svgURL(
      "<rect y='400' width='500' height='300' fill='#e8ddca'/><path d='M120 700V560A130 130 0 0 1 380 560V700Z' fill='#d9a58a'/><path d='M150 700V566A100 100 0 0 1 350 566V700' fill='none' stroke='#fffdf8' stroke-width='1.4' opacity='.7'/><circle cx='436' cy='76' r='34' fill='#e8ddca'/><circle cx='436' cy='76' r='34' fill='none' stroke='#4a4b36' stroke-width='1' opacity='.4' transform='translate(6 6)'/>" +
        scatter(
          Array.from({ length: 20 }, (_, i) => [
            30 + (i % 5) * 12,
            40 + Math.floor(i / 5) * 12,
          ]),
          (x, y) =>
            `<circle cx='${x}' cy='${y}' r='1.6' fill='#4a4b36' opacity='.35'/>`,
        ) +
        "<path d='M30 700C40 620 60 560 100 486' stroke='#4a4b36' stroke-width='1.4' fill='none' opacity='.7'/>" +
        lineLeaf(44, 640, 0.9, -80) +
        lineLeaf(58, 590, 0.9, -115) +
        lineLeaf(70, 560, 0.8, -60) +
        lineLeaf(86, 520, 0.8, -100) +
        "<path d='M470 700C460 620 440 560 400 486' stroke='#4a4b36' stroke-width='1.4' fill='none' opacity='.7'/>" +
        g(
          lineLeaf(44, 640, 0.9, -80) +
            lineLeaf(58, 590, 0.9, -115) +
            lineLeaf(70, 560, 0.8, -60) +
            lineLeaf(86, 520, 0.8, -100),
          "translate(500 0) scale(-1 1)",
        ) +
        "<path d='M40 400H460' stroke='#4a4b36' stroke-width='1' opacity='.3'/><circle cx='60' cy='336' r='10' fill='#d9a58a' opacity='.8'/><circle cx='444' cy='300' r='6' fill='#a9b79c'/>",
    ),
  },
  STYLE_CSS = `
  .paper{isolation:isolate}
  .paper::before{content:none;position:absolute;inset:0;pointer-events:none;z-index:-1;background-repeat:no-repeat;background-size:100% 100%}
  ${Object.keys(ART).map(
    (id) =>
      `.paper[data-style="${id}"]::before{content:"";background-image:${ART[id]}}`,
  ).join(`
  `)}
  .paper[data-style="std-botanical"]{background:#f5f6f0;padding-top:11%;--rule:transparent}
  .paper[data-style="std-black-gold"]{background:#171717;border-color:#171717;padding-top:13%;--rule:transparent;--foot:#c9a45c;--foot-bottom:6.6%;--mag-bottom:11%}
  .paper[data-style="std-blush-arch"]{background:#f6ede8;padding-top:12%;--rule:transparent}
  .paper[data-style="xmas-plaid"]{background:#fbf7f0;border-color:#a3202f;padding-top:23%;--rule:transparent;--foot-bottom:6.8%;--mag-bottom:11%}
  .paper[data-style="xmas-evergreen"]{background:#233a2c;border-color:#233a2c;padding-top:17%;--rule:transparent;--foot:#3e2f22}
  .paper[data-style="xmas-holly"]{background:#fbf8f2;padding-top:15%;--rule:transparent}
  .paper[data-style="bday-confetti"]{background:#fff8ec;padding-top:13%;--rule:transparent}
  .paper[data-style="bday-balloons"]{background:#fdf1ec;padding-top:21%;--rule:transparent}
  .paper[data-style="bday-stripes"]{background:#fff8ec;border-color:#f2b33d;padding-top:14%;--rule:transparent;--foot-bottom:6.8%;--mag-bottom:11%}
  .paper[data-style="grad-navy-gold"]{background:#1f2d40;border-color:#1f2d40;padding-top:15%;--rule:transparent;--foot:#c9b98f;--foot-bottom:6.6%;--mag-bottom:11%}
  .paper[data-style="grad-pennant"]{background:#faf8f3;padding-top:14%;--rule:transparent}
  .paper[data-style="grad-laurel"]{background:#f7f5ee;padding-top:12%;--rule:transparent}
  .paper[data-style="baby-clouds"]{background:#eaf1f5;padding-top:21%;--rule:transparent}
  .paper[data-style="baby-watercolor"]{background:#fffbf8;padding-top:14%;--rule:transparent}
  .paper[data-style="baby-gingham"]{background:#fffdf8;padding-top:21%;--rule:transparent}
  .paper[data-style="ty-kraft"]{background:#d9c29e;border-color:#c9b089;padding-top:13%;--rule:transparent;--foot:#5a4630;--foot-bottom:6.6%;--mag-bottom:11%}
  .paper[data-style="ty-wildflowers"]{background:#fbf8f1;padding-top:12%;--rule:transparent}
  .paper[data-style="ty-color-block"]{background:#fffdf8;padding-top:12%;--rule:transparent}
`;
// Artwork-only overlays. Heading, wording, ink and magnet remain separate live layers.
const ELUNORA_CARD_OVERLAYS = [
  {
    id: "ae-olive-botanical",
    key: "olive-botanical",
    label: "Olive Botanical",
    occasion: "save-the-date",
    bg: "#fffdf8",
    ac: "#576248",
    ink: "#4a4b36",
    headingTop: 17,
    file: "atelier-card-olive-botanical.png",
  },
  {
    id: "ae-romantic-ribbon",
    key: "romantic-ribbon",
    label: "Romantic Ribbon",
    occasion: "save-the-date",
    bg: "#fffdf8",
    ac: "#8b2536",
    ink: "#8b2536",
    headingTop: 21,
    file: "atelier-card-romantic-ribbon.png",
  },
  {
    id: "ae-modern-arch",
    key: "modern-arch",
    label: "Modern Arch",
    occasion: "save-the-date",
    bg: "#fffdf8",
    ac: "#787b60",
    ink: "#4a4b36",
    headingTop: 17,
    file: "atelier-card-modern-arch.png",
  },
  {
    id: "ae-evergreen-classic",
    key: "evergreen-classic",
    label: "Evergreen Classic",
    occasion: "christmas",
    bg: "#fffdf8",
    ac: "#2f4a35",
    ink: "#2f4a35",
    headingTop: 23,
    file: "atelier-card-evergreen-classic.png",
  },
  {
    id: "ae-cranberry-gingham",
    key: "cranberry-gingham",
    label: "Cranberry Gingham",
    occasion: "christmas",
    bg: "#fffdf8",
    ac: "#9d2835",
    ink: "#2f4a35",
    headingTop: 17,
    file: "atelier-card-cranberry-gingham.png",
  },
  {
    id: "ae-midnight-winter",
    key: "midnight-winter",
    label: "Midnight Winter",
    occasion: "christmas",
    bg: "#172638",
    ac: "#d7bf8e",
    ink: "#fffdf8",
    dark: true,
    headingTop: 17,
    file: "atelier-card-midnight-winter.png",
  },
  {
    id: "ae-holiday-valentine",
    key: "valentine",
    label: "Valentine Rose",
    heading: "Happy Valentine’s Day",
    bg: "#fffdf8",
    ac: "#a33b50",
    ink: "#8b2536",
    headingTop: 17,
    file: "atelier-card-holiday-valentine.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-halloween",
    key: "halloween",
    label: "Halloween Moon",
    heading: "Happy Halloween",
    bg: "#fdf7ed",
    ac: "#9d5d37",
    ink: "#4a3a3f",
    headingTop: 17,
    file: "atelier-card-holiday-halloween.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-thanksgiving",
    key: "thanksgiving",
    label: "Harvest Gratitude",
    heading: "Happy Thanksgiving",
    bg: "#fff8ed",
    ac: "#a5683e",
    ink: "#685036",
    headingTop: 17,
    file: "atelier-card-holiday-thanksgiving.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-new-year",
    key: "new-year",
    label: "New Year Starlight",
    heading: "Happy New Year",
    bg: "#182639",
    ac: "#c8ad73",
    ink: "#fffdf8",
    dark: true,
    headingTop: 17,
    file: "atelier-card-holiday-new-year.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-easter",
    key: "easter",
    label: "Easter Garden",
    heading: "Happy Easter",
    bg: "#fffdf8",
    ac: "#9ca98c",
    ink: "#58624a",
    headingTop: 17,
    file: "atelier-card-holiday-easter.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-hanukkah",
    key: "hanukkah",
    label: "Hanukkah Light",
    heading: "Happy Hanukkah",
    bg: "#fffdf8",
    ac: "#56749b",
    ink: "#2b4775",
    headingTop: 17,
    file: "atelier-card-holiday-hanukkah.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-eid",
    key: "eid",
    label: "Eid Moon & Lanterns",
    heading: "Eid Mubarak",
    bg: "#fffdf8",
    ac: "#b89a5d",
    ink: "#3f655f",
    headingTop: 17,
    file: "atelier-card-holiday-eid.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-diwali",
    key: "diwali",
    label: "Diwali Marigold",
    heading: "Happy Diwali",
    bg: "#fff9ed",
    ac: "#c2843a",
    ink: "#8a4c3c",
    headingTop: 17,
    file: "atelier-card-holiday-diwali.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-kwanzaa",
    key: "kwanzaa",
    label: "Kwanzaa Heritage",
    heading: "Joyous Kwanzaa",
    bg: "#fff9ee",
    ac: "#3c6c48",
    ink: "#303d31",
    headingTop: 17,
    file: "atelier-card-holiday-kwanzaa.png",
    occasion: "holiday",
  },
  {
    id: "ae-holiday-lunar-new-year",
    key: "lunar-new-year",
    label: "Lunar New Year Peony",
    heading: "Happy Lunar New Year",
    bg: "#fff8ee",
    ac: "#a83239",
    ink: "#8d2e37",
    headingTop: 17,
    file: "atelier-card-holiday-lunar-new-year.png",
    occasion: "holiday",
  },
];
const ELUNORA_OVERLAY_CSS = ELUNORA_CARD_OVERLAYS.map((s) => {
  const url = new URL(s.file, import.meta.url).href;
  return `.paper[data-style="${s.id}"]{background:${s.bg};--rule:transparent;--foot:${s.dark ? "#d7bf8e" : "#77745d"}}.paper[data-style="${s.id}"]::before{content:"";background-image:url(${JSON.stringify(url)})}.paper[data-style="${s.id}"] .heading{position:absolute;top:${s.headingTop}%;left:17%;width:66%;height:15%;margin:0;font-size:clamp(18px,10cqi,36px);line-height:1.05;overflow-wrap:anywhere;overflow:hidden}.paper[data-style="${s.id}"] .wording{position:absolute;top:39%;left:17%;width:66%;height:11%;margin:0;align-items:center}.paper[data-style="${s.id}"] .rule{display:none}`;
}).join("\n");
typeof HTMLElement < "u" &&
  !customElements.get("atelier-card-preview") &&
  customElements.define(
    "atelier-card-preview",
    class extends HTMLElement {
      static observedAttributes = [
        "card-wording",
        "couple-names",
        "event-date",
        "magnet-src",
        "lettering-color",
        "card-style",
        "view",
        "data-title",
        "data-caption",
        "data-heading",
        "data-placeholder",
        "data-empty",
        "data-overflow",
        "data-magnet-alt",
      ];
      constructor() {
        super();
        const root = this.attachShadow({ mode: "open" });
        root.innerHTML = `<style>
        :host{display:block;min-width:0;color:var(--ae-olive,#4a4b36);font:14px/1.5 Arial,sans-serif;contain:layout style}
        *{box-sizing:border-box}figure{margin:0}figcaption{font-size:13px;font-weight:600;letter-spacing:.025em;margin-bottom:12px}
        .stage{padding:28px 24px;background:var(--ae-ivory,#e7e5d9);border:1px solid var(--ae-sand,#d6d2bc);border-radius:8px;overflow:hidden}
        .paper{--rule:#b19a73;--foot:#77745d;--foot-bottom:3%;--mag-bottom:9%;container-type:inline-size;position:relative;aspect-ratio:5/7;max-width:340px;width:100%;margin:auto;background:#fffdf8;border:1px solid #d6d2bc;box-shadow:0 10px 25px #4547341c;padding:9% 8%;display:flex;flex-direction:column;align-items:stretch;text-align:center;color:#4a4b36;overflow:hidden;transition:background-color .25s ease}
        .rule{height:1px;width:24%;background:var(--rule);flex-shrink:0;margin:0 auto 7%}.heading{font-family:var(--ae-script,"Elunora Edwardian","Snell Roundhand",cursive);font-size:clamp(26px,14cqi,48px);font-weight:400;line-height:1.05;margin:0 0 8%;flex-shrink:0}
        .wording{font-family:var(--ae-serif,Georgia,serif);white-space:pre-wrap;overflow-wrap:anywhere;line-height:1.4;min-height:0;overflow:hidden;flex:1;display:flex;align-items:center;justify-content:center}.wording span{display:block;width:100%}.footer{font-size:clamp(6px,2.5cqi,9px);letter-spacing:.2em;text-transform:uppercase;margin-top:8%;flex-shrink:0;color:var(--foot)}
        .magnet{display:none;position:absolute;bottom:var(--mag-bottom);left:23%;width:54%;aspect-ratio:1;transform:rotate(-4deg);box-shadow:3px 8px 13px #292b2436;background:#eeece3;border:1px solid #d6d2bc;place-items:center;overflow:hidden}
        .magnet img{display:block;width:100%;height:100%;object-fit:contain}.empty{padding:12%;font-size:clamp(9px,4cqi,14px);line-height:1.5;color:#696950}.caption,.overflow{font-size:12px;line-height:1.5;margin:12px 0 0;color:inherit}.overflow{font-weight:600}.paper.set .magnet{display:grid}.paper.set .wording{flex:none;height:32%;align-items:flex-start}.paper.set .footer{position:absolute;bottom:var(--foot-bottom);left:0;width:100%;margin:0}.paper.set .heading{margin-bottom:6%}[hidden]{display:none!important}
        ${STYLE_CSS}${ELUNORA_OVERLAY_CSS}
        @media(prefers-reduced-motion:reduce){*{scroll-behavior:auto}.paper{transition:none}}
      </style><figure><figcaption></figcaption><div class="stage"><div class="paper" data-style="classic"><div class="rule" aria-hidden="true"></div><p class="heading"></p><div class="wording"><span></span></div><div class="magnet"><img hidden><span class="empty"></span></div><div class="footer" aria-hidden="true">Atelier Elunora</div></div></div><p class="overflow" hidden></p><p class="caption"></p></figure>`;
      }
      connectedCallback() {
        (this.render(),
          this.observer?.disconnect(),
          (this.observer = new ResizeObserver(() => this.scheduleFit())),
          this.observer.observe(this.shadowRoot.querySelector(".paper")),
          document.fonts?.ready.then(() => {
            this.isConnected && this.scheduleFit();
          }));
      }
      disconnectedCallback() {
        (this.observer?.disconnect(), cancelAnimationFrame(this.frame));
      }
      attributeChangedCallback() {
        this.isConnected && this.render();
      }
      label(name, fallback) {
        return this.getAttribute("data-" + name) || fallback;
      }
      render() {
        const r = this.shadowRoot,
          set = this.getAttribute("view") === "set",
          wording = previewText(
            this.getAttribute("card-wording"),
            this.getAttribute("couple-names"),
            this.getAttribute("event-date"),
          ),
          paper = r.querySelector(".paper");
        ((r.querySelector("figcaption").textContent = this.label(
          "title",
          set ? "Your magnet + matching card" : "Your matching card",
        )),
          (r.querySelector(".heading").textContent = this.label(
            "heading",
            "Save the date",
          )),
          (r.querySelector(".wording span").textContent =
            wording ||
            this.label(
              "placeholder",
              `Your names
Your wedding date`,
            )),
          paper.classList.toggle("set", set),
          (paper.dataset.style = safeCardStyle(
            this.getAttribute("card-style"),
          )));
        const ink = this.getAttribute("lettering-color");
        ((paper.style.color = /^#[0-9a-f]{6}$/i.test(ink || "")
          ? ink
          : "#4a4b36"),
          (r.querySelector(".caption").textContent = this.label(
            "caption",
            "Layout preview \xB7 your digital proof confirms the final design.",
          )),
          (r.querySelector(".overflow").textContent = this.label(
            "overflow",
            "Long wording needs a custom layout. We\u2019ll confirm it in your digital proof.",
          )));
        const src = safeMagnetPreview(this.getAttribute("magnet-src")),
          img = r.querySelector("img"),
          empty = r.querySelector(".empty");
        ((img.hidden = !src),
          (empty.hidden = !!src),
          src
            ? img.getAttribute("src") !== src && (img.src = src)
            : img.removeAttribute("src"),
          (img.alt = this.label(
            "magnet-alt",
            "Your personalized photo magnet on its matching save-the-date card",
          )),
          (empty.textContent = this.label(
            "empty",
            "Your photo magnet will appear here",
          )),
          this.scheduleFit());
      }
      scheduleFit() {
        (cancelAnimationFrame(this.frame),
          (this.frame = requestAnimationFrame(() => this.fit())));
      }
      fit() {
        const r = this.shadowRoot,
          paper = r.querySelector(".paper"),
          box = r.querySelector(".wording"),
          text = r.querySelector(".wording span");
        if (!paper.clientWidth || !box.clientHeight) return;
        let size = Math.min(23, Math.max(14, paper.clientWidth * 0.068)),
          minimum = Math.max(7, paper.clientWidth * 0.024);
        for (
          text.style.fontSize = size + "px";
          text.scrollHeight > box.clientHeight + 1 && size > minimum;
        )
          ((size = Math.max(minimum, size - 0.5)),
            (text.style.fontSize = size + "px"));
        r.querySelector(".overflow").hidden =
          text.scrollHeight <= box.clientHeight + 1;
      }
    },
  );

// Keep user headings inside their reserved text area as wording changes.
if (typeof HTMLElement !== "undefined") {
  const Preview = customElements.get("atelier-card-preview");
  if (Preview) {
    const fit = Preview.prototype.fit;
    Preview.prototype.fit = function () {
      fit.call(this);
      const paper = this.shadowRoot.querySelector(".paper");
      if (!ELUNORA_CARD_OVERLAYS.some((s) => s.id === paper.dataset.style))
        return;
      const heading = this.shadowRoot.querySelector(".heading");
      let size = Math.min(36, Math.max(18, paper.clientWidth * 0.1));
      heading.style.fontSize = size + "px";
      while (heading.scrollHeight > heading.clientHeight + 1 && size > 12) {
        size -= 0.5;
        heading.style.fontSize = size + "px";
      }
      if (heading.scrollHeight > heading.clientHeight + 1)
        this.shadowRoot.querySelector(".overflow").hidden = false;
    };
  }
}

